import { render } from "./UserCorporatePage.vue?vue&type=template&id=50bec996&scoped=true&ts=true&lang=pug"
import script from "./UserCorporatePage.vue?vue&type=script&lang=ts"
export * from "./UserCorporatePage.vue?vue&type=script&lang=ts"

import "./UserCorporatePage.vue?vue&type=style&index=0&id=50bec996&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bec996"]])

export default __exports__